(function () {
  var _origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    return _origFetch.apply(this, arguments).then(function (response) {
      if (url.indexOf('/cart/add') !== -1) {
        wimCheckCartSubscriptionVariants();
      }
      return response;
    });
  };
})();

document.addEventListener("DOMContentLoaded", function () {
  initQuickFeatureTooltips();
  initSubsPopupInfo();
  wimCheckCartSubscriptionVariants();
});

function initCartUpsellDrag() {
  const el = document.getElementById('cart-upsell-drawer');
  if (!el || el.dataset.dragInitialized) return;
  el.dataset.dragInitialized = 'true';

  let isDown = false;
  let startX;
  let scrollLeft;
  let hasDragged = false;

  el.style.cursor = 'grab';

  function endDrag() {
    if (!isDown) return;
    isDown = false;
    el.style.cursor = 'grab';
    el.style.userSelect = '';
  }

  el.addEventListener('mousedown', (e) => {
    isDown = true;
    hasDragged = false;
    startX = e.pageX - el.offsetLeft;
    scrollLeft = el.scrollLeft;
    el.style.cursor = 'grabbing';
    el.style.userSelect = 'none';
  });

  el.addEventListener('mouseleave', endDrag);
  el.addEventListener('mouseup', endDrag);

  el.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - el.offsetLeft;
    const walk = (x - startX) * 1.5;
    if (Math.abs(walk) > 5) hasDragged = true;
    el.scrollLeft = scrollLeft - walk;
  });

  el.addEventListener('click', (e) => {
    if (hasDragged) e.stopPropagation();
  }, true);
}

function initQuickFeatureTooltips() {

  let viewportWidth = window.innerWidth;

  window.addEventListener('resize', () => {
    viewportWidth = window.innerWidth;
  });

  document.querySelectorAll('.quick-feature-tooltip').forEach((tooltip) => {

    const content = tooltip.querySelector('.quick-feature-tooltip-content');
    const trigger = tooltip.querySelector('.quick-feature-tooltip-trigger');
    const closeIcon = tooltip.querySelector('.quick-feature-tooltip-close-icon')?.innerHTML || '';

    trigger.addEventListener('click', (e) => {

      if (viewportWidth <= 768) {

        e.preventDefault();
        e.stopPropagation();

        openQuickFeaturePopup(content.innerHTML, closeIcon);

        return;
      }

    });

    tooltip.addEventListener('toggle', () => {

      if (viewportWidth <= 768) return;

      if (!tooltip.open) {
        content.style.left = '';
        content.style.right = '';
        content.style.transform = '';
        content.style.opacity = '';
        content.style.visibility = '';
        content.classList.remove('no-arrow');
        return;
      }

      document.querySelectorAll('.quick-feature-tooltip[open]').forEach((other) => {
        if (other !== tooltip) other.removeAttribute('open');
      });

      content.style.opacity = '0';
      content.style.visibility = 'hidden';

      content.style.left = '';
      content.style.right = '';
      content.style.transform = '';

      requestAnimationFrame(() => {

        const rect = content.getBoundingClientRect();
        const overflowRight = rect.right - viewportWidth;
        const overflowLeft = rect.left;

        let moved = false;

        if (overflowRight > 0) {
          content.style.left = 'auto';
          content.style.right = '0';
          content.style.transform = 'none';
          moved = true;
        }

        if (overflowLeft < 0) {
          content.style.left = '0';
          content.style.right = 'auto';
          content.style.transform = 'none';
          moved = true;
        }

        if (moved) {
          content.classList.add('no-arrow');
        }

        requestAnimationFrame(() => {
          content.style.visibility = 'visible';
          content.style.opacity = '1';
        });

      });

    });

  });

  document.addEventListener('click', (e) => {
    if (viewportWidth <= 768) return;
    document.querySelectorAll('.quick-feature-tooltip[open]').forEach((tooltip) => {
      if (!tooltip.contains(e.target)) tooltip.removeAttribute('open');
    });
  });

}

function openQuickFeaturePopup(html, closeIcon) {

  let popup = document.getElementById('quickFeaturePopup');

  if (!popup) {

    popup = document.createElement('div');
    popup.id = 'quickFeaturePopup';
    popup.className = 'quick-feature-popup';

    popup.innerHTML = `
      <div class="quick-feature-popup-backdrop"></div>
      <div class="quick-feature-popup-inner">
        <button class="quick-feature-popup-close"></button>
        <div class="quick-feature-popup-content"></div>
      </div>
    `;

    document.body.appendChild(popup);

    popup.querySelector('.quick-feature-popup-backdrop').onclick = () => {
      popup.classList.remove('open');
    };

  }

  const closeBtn = popup.querySelector('.quick-feature-popup-close');
  const content = popup.querySelector('.quick-feature-popup-content');

  content.innerHTML = html;

  closeBtn.innerHTML = closeIcon;

  closeBtn.onclick = () => popup.classList.remove('open');

  popup.classList.remove('quick-feature-popup--subs');
  popup.classList.add('open');

}

function initSubsPopupInfo() {

  document.querySelectorAll('[data-subs-popup-trigger]').forEach((trigger) => {

    const sourceEl = trigger.closest('p').parentElement.querySelector('[data-subs-popup-source]');

    if (!sourceEl) return;

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      openQuickFeaturePopupFromEl(sourceEl);
    });

  });

}

function openQuickFeaturePopupFromEl(sourceEl, closeIcon = '&times;') {

  let popup = document.getElementById('quickFeaturePopup');

  if (!popup) {

    popup = document.createElement('div');
    popup.id = 'quickFeaturePopup';
    popup.className = 'quick-feature-popup';

    popup.innerHTML = `
      <div class="quick-feature-popup-backdrop"></div>
      <div class="quick-feature-popup-inner">
        <button class="quick-feature-popup-close"></button>
        <div class="quick-feature-popup-content"></div>
      </div>
    `;

    document.body.appendChild(popup);

    popup.querySelector('.quick-feature-popup-backdrop').onclick = () => {
      popup.classList.remove('open');
    };

  }

  const closeBtn = popup.querySelector('.quick-feature-popup-close');
  const content = popup.querySelector('.quick-feature-popup-content');

  content.innerHTML = '';
  const clone = sourceEl.cloneNode(true);
  clone.classList.remove('hidden');
  content.appendChild(clone);

  const inlineClose = content.querySelector('[data-subs-popup-close]');
  if (inlineClose) {
    inlineClose.onclick = () => popup.classList.remove('open');
    closeBtn.style.display = 'none';
  } else {
    closeBtn.style.display = '';
    closeBtn.innerHTML = closeIcon;
    closeBtn.onclick = () => popup.classList.remove('open');
  }

  popup.classList.add('quick-feature-popup--subs', 'open');

}

async function wimCheckCartSubscriptionVariants() {
  try {
    /*
    const themeParam = (window.Shopify && window.Shopify.theme && window.Shopify.theme.id)
      ? '&preview_theme_id=' + window.Shopify.theme.id
      : '';
    const response = await fetch('/?sections=wim-cart-subscription-check' + themeParam);
    */
    // Fix theme preview when not on design_mode or admin
    const response = await fetch('/?sections=wim-cart-subscription-check');
    if (!response.ok) return;
    const data = await response.json();

    const sectionHtml = data['wim-cart-subscription-check'];
    if (!sectionHtml) return;

    const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const jsonEl = doc.getElementById('wim-cart-subscription-check-json');
    if (!jsonEl) return;

    let items;
    try { items = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    if (!Array.isArray(items) || items.length === 0) return;

    const subscriptionItems = items.filter(item => item.isSubscription === true);
    if (subscriptionItems.length === 0) return;

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    await Promise.allSettled(
      subscriptionItems.map(item =>
        fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        })
      )
    );

    const names = subscriptionItems.map(item => {
      const variant = item.variant && item.variant !== 'Default Title' ? ` ${item.variant}` : '';
      return `<strong>${item.title}${variant}</strong>`;
    }).join('<br/> ');
    const singular = subscriptionItems.length === 1;
    const i18n = window.wimI18n || {};
    const removedMsg = (singular
      ? (i18n.cartRemovedOne || '%{title}')
      : (i18n.cartRemovedOther || '%{titles}')
    ).replace('%{title}', names).replace('%{titles}', names);
    const createPlanText = i18n.cartCreatePlan || 'Crea tu plan';
    const createPlanSuffix = i18n.cartCreatePlanSuffix || '';
    const createPlanHtml = window.wimWizardUrl
      ? `<a href="${window.wimWizardUrl}">${createPlanText}</a>`
      : createPlanText;
    const closeIcon = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.586047 12.0001C0.470144 12.0001 0.356837 11.9657 0.26046 11.9014C0.164083 11.837 0.0889654 11.7455 0.0446082 11.6384C0.000250996 11.5313 -0.0113527 11.4135 0.0112649 11.2998C0.0338824 11.1861 0.0897052 11.0817 0.171672 10.9998L10.9998 0.17164C11.1097 0.0617407 11.2588 0 11.4142 0C11.5696 0 11.7186 0.0617407 11.8285 0.17164C11.9384 0.281539 12.0002 0.430594 12.0002 0.586015C12.0002 0.741436 11.9384 0.890491 11.8285 1.00039L1.00042 11.8285C0.946056 11.883 0.881462 11.9262 0.810351 11.9556C0.739239 11.9851 0.663012 12.0002 0.586047 12.0001Z" fill="currentColor"></path><path d="M11.4141 12.0001C11.3372 12.0002 11.2609 11.9851 11.1898 11.9556C11.1187 11.9262 11.0541 11.883 10.9998 11.8285L0.17164 1.00039C0.0617407 0.890491 0 0.741436 0 0.586015C0 0.430594 0.0617407 0.281539 0.17164 0.17164C0.281539 0.0617407 0.430594 0 0.586015 0C0.741436 0 0.890491 0.0617407 1.00039 0.17164L11.8285 10.9998C11.9105 11.0817 11.9663 11.1861 11.9889 11.2998C12.0115 11.4135 11.9999 11.5313 11.9556 11.6384C11.9112 11.7455 11.8361 11.837 11.7397 11.9014C11.6433 11.9657 11.53 12.0001 11.4141 12.0001Z" fill="currentColor"></path></svg>`;
    openQuickFeaturePopup(
      `<p style="margin:0 0 12px">${removedMsg}</p>
      <p style="margin:0;font-size:0.875em;opacity:0.7">${createPlanHtml} ${createPlanSuffix}</p>`,
      closeIcon
    );

    const popup = document.getElementById('quickFeaturePopup');
    if (!popup) return;
    popup.addEventListener('click', function onDismiss() {
      if (!popup.classList.contains('open')) {
        popup.removeEventListener('click', onDismiss);
        window.location.reload();
      }
    });

  } catch (e) {
    // Fallo silencioso
  }
}